(function() {
    'use strict';

    angular
        .module('telestatApp')
        .component('dateFilter', {
            templateUrl: 'app/components/date-filter/date-filter.template.html',
            controller: DateFilterController,
            controllerAs: 'vm',
            bindings: {
                data: '=',
            }
        });

    DateFilterController.$inject = [];

    function DateFilterController () {
        var vm = this;

        vm.dateFilterDay = false;
        vm.dateFilterReadonly = true;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        // Can't use $locale.DATETIME_FORMATS.shortDate due first page loading problem - $locale may be not initialized and applied "en" version.
        vm.dateformat = "dd.MM.yy";

        vm.search = search;
        vm.data.updateDateFilterType = updateDateFilterType;
        vm.dateFilterType = vm.data.pagingParams.searchType;
        vm.startDate = vm.data.pagingParams.startDate;
        vm.endDate = vm.data.pagingParams.endDate;
        vm.allActive = vm.data.allActive;
        vm.data.setFilterType = setFilterType;

        updateDateFilterType();
        vm.data.initCallBack();

        function openCalendar (date) {
            if(!vm.dateFilterReadonly) {
                vm.datePickerOpenStatus[date] = true;
            }
        }

        function search (date, oldDateFilterType) {
            if(oldDateFilterType != vm.dateFilterType) {
                vm.startDate = null;
                vm.endDate = null;
            }
            if (vm.dateFilterType == 'range' && vm.startDate != null && vm.endDate != null) {
                var startDate = new Date(vm.startDate);
                var endDate = new Date(vm.endDate);
                if (startDate.getTime() > endDate.getTime()) {
                    if (date == 'endDate') {
                        vm.startDate = endDate;
                    } else {
                        vm.endDate = startDate;
                    }
                }
            }
            vm.data.dateFilterType = vm.dateFilterType;
            vm.data.search(vm.data.searchQuery);
        }

        function setFilterType (type) {
            vm.dateFilterType = type;
        }

        // search with time limits
        function updateDateFilterType () {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var day = today.getDay() - 1;// сколько дней прошло с понедельника
            if (day < 0) day += 7;// воскресенье 0 день.
            if (!vm.allActive && !vm.dateFilterType) {
                vm.dateFilterType = 'lastmonth';// default case
            }
            switch (vm.dateFilterType) {
                case 'day':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = false;
                    if (vm.startDate == null) {
                        vm.startDate = new Date();
                        vm.endDate = new Date();
                    } else {
                        vm.startDate = new Date(vm.startDate);
                        vm.endDate = new Date(vm.startDate);
                    }
                    break;
                case 'today':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = true;
                    vm.startDate = today;
                    vm.endDate = new Date(today);
                    break;
                case 'yesterday':
                    vm.dateFilterDay = true;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date(today);
                    vm.startDate.setDate(vm.startDate.getDate()-1);
                    vm.endDate = vm.startDate;
                    break;
                case 'thisweek':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(vm.startDate.getDate()-day);
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate()+6-day);
                    break;
                case 'lastweek':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(vm.startDate.getDate()-7-day);
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate()-day-1);
                    break;
                case 'thismonth':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.startDate.setDate(1);// условие поиска >=
                    vm.endDate = new Date();
                    vm.endDate.setDate(vm.endDate.getDate());// условие поиска <=
                    break;
                case 'range':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = false;
                    if (vm.endDate == null) {
                        vm.endDate = new Date();
                        vm.endDate.setDate(vm.endDate.getDate()-7);// Конечная дата на неделю раньше текущей даты
                    } else {
                        vm.endDate = new Date(vm.endDate);
                    }
                    if (vm.startDate == null) {
                        vm.startDate = new Date();
                        vm.startDate.setDate(1);
                        if (vm.startDate.getTime() > vm.endDate.getTime()) {
                            vm.startDate.setMonth(vm.startDate.getMonth()-1);
                        }
                    } else {
                        vm.startDate = new Date(vm.startDate);
                    }
                    break;
                case 'lastmonth':
                    vm.dateFilterDay = false;
                    vm.dateFilterReadonly = true;
                    vm.startDate = new Date();
                    vm.endDate = new Date();
                    vm.startDate.setDate(1);
                    vm.startDate.setMonth(vm.startDate.getMonth()-1);
                    vm.endDate.setDate(1);
                    vm.endDate.setDate(vm.endDate.getDate()-1);// условие поиска <=
                    break;
                default:
                    vm.dateFilterDay = false;
                    vm.endDate = null;
                    vm.startDate = null;
                    break;
            }
            //
            vm.data.dateFilterType = vm.dateFilterType;
            vm.data.endDate = vm.endDate;
            vm.data.startDate = vm.startDate;
        }

    }


})();

